export default __webpack_public_path__ + "static/media/checkbox-checked_grey.287acabb.png";